import { useRecoilValue } from "recoil";
import { taskCounterTemplateSearchAtom } from "../miscellaneous/taskCounterTemplateSearchAtom";

export const useTaskCounterTemplateSearchValue = () => {
  return useRecoilValue(taskCounterTemplateSearchAtom);
};
